<template>
  <div>
    <div class="cart-box">
      <div class="nb">
        <div class="cart-step">
          <ul>
            <li class="cart1"><i></i>{{ $t('payResult.cart') }}</li>
            <li class="cart2 oncart2"><i></i>{{ $t('payResult.confirmOrder') }}</li>
            <li class="cart3 oncart3"><i></i>{{ $t('payResult.payment') }}</li>
            <li class="cart4 oncart4" v-if="orderInfo.state =='0'"><i></i>{{ $t('payResult.paySuccess') }}</li>
            <li class="cart4 oncart4" v-if="orderInfo.state =='9'"><i></i>{{ $t('payResult.orderCanceled') }}</li>
          </ul>
        </div>
        <div class="add-deliver">
          <div class="cart-title">
            <h3><span>{{ $t('payResult.payResult') }}</span></h3>
          </div>
          <div>
            <div class="result-message">
              <span v-if="orderInfo.state =='0'">{{ $t('payResult.paySuccessMsg') }}</span>
              <span v-if="orderInfo.state =='9'">{{ $t('payResult.orderCanceledMsg') }}</span>
            </div>
          </div>
        </div>
        <div class="add-deliver">
          <div class="cart-title">
            <h3><span>{{ $t('payResult.receiverInfo') }}</span></h3>
          </div>
          <div>
            <div class="sh-address">
              <ul>
                <li class="default-add">
                  <div class="inner-infos">
                    <div class="addr-hd"><span>{{orderInfo.storeOrderAddressDto.username}}</span></div>
                    <div class="addr-bd">
                      <span></span><span>{{orderInfo.storeOrderAddressDto.address}}{{orderInfo.storeOrderAddressDto.tel}}</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="goods-infor">
          <div class="cart-title">
            <h3><span>{{ $t('payResult.goodsInfo') }}</span></h3>
          </div>
          <div class="goods-table">
            <div class="goods-thead">
              <div class="col col1">
                {{ $t('payResult.goods') }}
              </div>
              <div class="col col3">
                {{ $t('payResult.price') }}
              </div>
              <div class="col col4">
                {{ $t('payResult.quantity') }}
              </div>
              <div class="col col5">
                {{ $t('payResult.subtotal') }}
              </div>
            </div>
            <div class="goods-tbody">
              <div class="goodinfor" v-for="(prod, index) in orderInfo.storeOrderCartDtos" :key="index">
                <div class="col col1 goods-title-pic">
                  <a href="https://www.121wuye.com/sh4nb-g.html"><img :src="prod.coverPhoto" width="60"
                      height="60"></a>
                  <div class="goods-describ elli">
                    <p><a href="https://www.121wuye.com/sh4nb-g.html">{{prod.prodName}}</a></p>
                    <p></p>
                  </div>
                </div>
                <div class="col col3 goods-price"> ￥{{prod.price}} </div>
                <div class="col col4 good-num"> {{prod.cartNum}} </div>
                <div class="col col5 orange-bold xiaoji" style="border-bottom: none;"> ￥{{prod.cartNum * prod.price}} </div>
              </div>
            </div>
          </div>
        </div>
        <div class="style-zhifu">
          <div class="fare-result">
            <div class="cart-title">
              <h3><span>{{ $t('payResult.settlementInfo') }}</span></h3>
            </div>
            <div class="result-box">
              <ul>
                <li class="first">
                  <div class="calu-box">
                    <p class="slivergrey"><span><b class="orange-bold">{{orderInfo.totalNum}}</b> {{ $t('payResult.goodsCount') }} ，{{ $t('payResult.total') }}：</span><span class="orange-bold big">￥<b
                          id="payAmount">{{orderInfo.totalPrice}}</b></span></p>
                    <p class="slivergrey"><span>{{ $t('payResult.freight') }}：</span><span class="txtmoney">￥<b
                          id="expfee">0.00</b></span></p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { listStoreOrder } from '@/api/plateform/payResultApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'PayResult',
  data() {
    return {
      orderInfo: {
        "appId": "",
        "freightPrice": "",
        "oId": "",
        "orderId": "",
        "personId": "",
        "personName": "",
        "records": 0,
        "remark": "",
        "stateName": "",
        "storeOrderAddressDto": {},
        "storeOrderCartDtos": []
      },
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    console.log(this.shopId)
    this._listOrders(1, 1)
  },
  methods: {
    async _listOrders(page, rows) {
      try {
        const param = {
          page: page,
          row: rows,
          orderId: this.$route.query.orderId
        }
        const res = await listStoreOrder(param)
        const _orderInfo = res.data[0]
        if (!_orderInfo) {
          this.$message.error(this.$t('payResult.invalidOrder'))
          return
        }
        this.orderInfo = _orderInfo
        if (this.orderInfo.state === "1") {
          this.$router.push(`/pages/plateform/pay?orderId=${this.orderInfo.orderId}`)
          return
        }
        this._caculTotalMount()
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _caculTotalMount() {
      let j = 0, k = 0
      this.orderInfo.storeOrderCartDtos.forEach(item => {
        if (!isNaN(item.cartNum) && !isNaN(item.price)) {
          j += parseFloat(item.cartNum) * parseFloat(item.price).toFixed(2)
          k += parseFloat(item.cartNum)
        } else {
          this.orderInfo.totalMount = this.$t('payResult.inputCorrectNumber')
          this.orderInfo.totalNum = this.$t('payResult.inputCorrectNumber')
          throw Error()
        }
      })
      this.orderInfo.totalMount = j.toFixed(2)
      this.orderInfo.totalNum = k
    }
  }
}
</script>

<style scoped>
.cart-box {
  width: 100%;
}

.nb {
  max-width: 1200px;
  margin: 0 auto;
}

.cart-step ul {
  display: flex;
  justify-content: space-between;
  padding: 0;
  margin: 20px 0;
}

.cart-step li {
  list-style: none;
  position: relative;
  text-align: center;
  flex: 1;
}

.cart-step li i {
  display: block;
  margin: 0 auto 10px;
  width: 30px;
  height: 30px;
  background: #ccc;
  border-radius: 50%;
}

.cart-step li.oncart2 i,
.cart-step li.oncart3 i,
.cart-step li.oncart4 i {
  background: #67C23A;
}

.result-message {
  height: 108px;
  border: 1px solid #e0e0e0;
  background-color: #fff;
  padding: 0 0 18px;
  text-align: center;
  font-size: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: green;
}

.cart-title {
  margin: 20px 0;
}

.cart-title h3 {
  font-size: 18px;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 10px;
}

.goods-table {
  border: 1px solid #e0e0e0;
  margin-bottom: 20px;
}

.goods-thead {
  display: flex;
  background: #f5f5f5;
  padding: 10px 0;
  border-bottom: 1px solid #e0e0e0;
}

.goods-thead .col {
  flex: 1;
  text-align: center;
}

.goods-tbody {
  padding: 15px 0;
}

.goodinfor {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #e0e0e0;
}

.goodinfor .col {
  flex: 1;
  text-align: center;
}

.goods-title-pic {
  display: flex;
  align-items: center;
  justify-content: center;
}

.goods-describ {
  margin-left: 15px;
  text-align: left;
}

.orange-bold {
  color: #FF6700;
  font-weight: bold;
}

.big {
  font-size: 20px;
}

.slivergrey {
  color: #666;
}

.result-box ul {
  padding: 0;
  margin: 0;
}

.result-box li {
  list-style: none;
  padding: 15px;
  border: 1px solid #e0e0e0;
  margin-bottom: 20px;
}

.calu-box {
  text-align: right;
}

.calu-box p {
  margin: 5px 0;
}

.elli {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>